import { ClaimDeductiblesResponse } from '@cms-max/medicare-api-sdk'
import { medicareApiClient } from 'clients/medicareApiClient'
import { useQuery } from 'react-query'

// Currently, the deductibles endpoint requires that the bene combined endpoint have already been hit;
// as a result, we need to support waiting to make this query — hence `enabled`
type HookOpts = { enabled?: boolean }
export const useDeductiblesQuery = ({ enabled }: HookOpts = { enabled: true }) => {
  const fetchDeductibles = async () => {
    return await medicareApiClient.asyncGetClaimsDeductibles()
  }

  return useQuery<ClaimDeductiblesResponse | undefined>('deductibles', fetchDeductibles, { enabled })
}
